class AssessmentsSyncMessageController {
    /*@ngInject*/
    constructor($state, utilityService, sharedAjsService) {
        this.$state = $state;
        this.utilityService = utilityService;
        this.sharedAjsService = sharedAjsService;
    }
    $onInit() {
        this.showSyncMessage = false;
        this.displayNavigationToAssessments = false;
        this.listenToAssessmentsSync();
    }
    listenToAssessmentsSync() {
        this.sharedAjsService.receiveAssessmentsSyncMessage().then(null, null, (message) => {
            this.displayNavigationToAssessments = !message.includes('Syncing Assessments');
            if (this.displayNavigationToAssessments) {
                this.syncMessage = message + " Go to Assessments";
            }
            else {
                this.syncMessage = message;
            }
            this.showSyncMessage = true;
        });
    }
    goToAssessments() {
        if (this.$state.current.name === 'missioncontrol.assessmentManagement') {
            this.$state.reload();
        }
        else {
            this.$state.go('missioncontrol.assessmentManagement', { reload: true });
        }
        this.showSyncMessage = false;
    }
}
AssessmentsSyncMessageController.$inject = ['$state', 'utilityService', 'sharedAjsService'];
// import * as TEMPLATE from './user-header.html';
import * as TEMPLATE from 'raw-loader!./assessments-sync-message.html';
export const AssessmentsSyncMessageComponent = {
    selector: 'assessmentsSyncMessage',
    component: {
        controller: AssessmentsSyncMessageController,
        // templateUrl: 'app/components/assessmentsSyncMessage/assessments-sync-message.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=assessments-sync-message.component.js.map